export const acceptCookiesName = 'acceptCookies';

export const cookieConsentStates = [
	'unknown',
	'block-external',
	'all',
] as const;
export type CookieConsentState = (typeof cookieConsentStates)[number];
export type CookieWidget =
	| 'cookiebar-select'
	| 'videobar-select'
	| 'settingsbar-select'
	| 'localstorage-select';

export type CookieOptions = {
	/** maxAge in seconds */
	maxAge: number;
};
export const cookieConsentOptions: CookieOptions = {
	maxAge: 60 * 60 * 24 * 365, // 1 year
};
